import React from "react"
import Layout from "./src/components/Layout"
// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}
export const shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition
    }) => {
    const currentPosition = getSavedScrollPosition(location)

    window.scrollTo(...(currentPosition || [0, 0]))

    return false
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location && prevLocation)
    location.fromPost = true;
}

// const transitionDelay = 350;

// const getLatestSavedScrollPosition = ({ pathname, key }) => {
//   const fullKey = `@@scroll|${pathname}|${key}`;
//   return sessionStorage.getItem(fullKey);
// };

// export const shouldUpdateScroll = ({ routerProps: { location } }) => {
//   console.log("shouldUpdateScroll");
//   if (location.action === "PUSH") {
//     window.setTimeout(() => window.scrollTo(0, 0), 350);
//   } else {
//     const yPosition = getLatestSavedScrollPosition(location);
//     window.setTimeout(() => window.scrollTo(0, yPosition || 0), 350);
//   }
//   return false;
// };

// gatsby-browser.js
// export const onRouteUpdate = ({ location, prevLocation }) => {
//   console.log("new pathname", location.pathname)
//   console.log("old pathname", prevLocation ? prevLocation.pathname : null)
// }
